import _ from 'lodash';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Component } from 'react';

import { Button, Col, Row } from 'antd';
import { makeObservable } from 'mobx';
import WorkOrderLineItemContext from '../LineItems/WorkOrderLineItemContext';
import WorkOrderLineItemIssuesItem from './WOLineItemIssuesItem';
import { PlusCircleOutlined } from '@ant-design/icons';

class WorkOrderLineItemIssues extends Component {
  static contextType = WorkOrderLineItemContext;

  static propTypes = {
    childRef: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.any,
    onAddItem: PropTypes.func,
    onRemoveItem: PropTypes.func,
    currentCarIssues: PropTypes.array,
    onUpdateLocalItem: PropTypes.func.isRequired,
  };

  state = {};

  issuesItemsRef = {};

  componentDidMount() {
    const { childRef } = this.props;
    childRef(this);
  }

  onAddItem = () => {
    this.forceUpdate();
  };

  onRemoveItem = (event, itemKey) => {
    if (this.props.onRemoveItem) {
      this.props.onRemoveItem(event, itemKey);
    }
  };

  render() {
    const { screenSize } = this.context;

    if (!_.isEmpty(this.props.items)) {
      const addDescription = `Add ${this.props.description}`;
      return (
        <Row gutter={[8, 8]}>
          <Col span={24}>
            {this.props.items.map((mapItem, index) => {
              return (
                <div key={mapItem.key}>
                  <WorkOrderLineItemIssuesItem
                    displayIcon={index === 0}
                    key={mapItem.key}
                    item={mapItem}
                    currentCarIssues={this.props.currentCarIssues}
                    childRef={(ref) => (this.issuesItemsRef[index] = ref)}
                    onRemoveItem={this.onRemoveItem}
                    onUpdateLocalItem={(newVal) =>
                      this.props.onUpdateLocalItem(mapItem.key, newVal)
                    }
                  />
                  {index === this.props.items.length - 1 && (
                    <Button
                      style={{
                        display: 'block',
                        marginLeft: screenSize <= 575 ? 0 : 35,
                      }}
                      icon={<PlusCircleOutlined />}
                      type="link"
                      onClick={this.props.onAddItem}
                    >
                      {addDescription}
                    </Button>
                  )}
                </div>
              );
            })}
          </Col>
        </Row>
      );
    }
    return <></>;
  }
  constructor() {
    super();
    makeObservable(this, {});
  }
}

export default observer(WorkOrderLineItemIssues);
